// extracted by mini-css-extract-plugin
export default {"container":"Uq-z","heading":"Vq-z","text":"Wq-z","info":"Xq-z","link":"Yq-z","fullMaxWidth":"Zq-z"};